import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'id',
  },
  created_at: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'datetime',
  },
  so_id: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  status: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  io_id: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'integer',
  },
  order: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'belongs_to',
    extra: {
      association_name: 'order',
      model_name: 'JushuitanOrder',
    },
  },
  o_id: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'belongs_to',
    extra: {
      association_name: 'order',
      model_name: 'JushuitanOrder',
    },
  },
  shop: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'belongs_to',
    extra: {
      association_name: 'shop',
      model_name: 'JushuitanShop',
    },
  },
  shop_id: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'belongs_to',
    extra: {
      association_name: 'shop',
      model_name: 'JushuitanShop',
    },
  },
  modified: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'datetime',
  },
  kind: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'enum',
  },
  order_type: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  pay_amount: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  io_date: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  paid_amount: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  free_amount: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  freight: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  items: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  pay_date: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  logistics_company: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
  l_id: {
    model_name: 'JushuitanInventoryOut',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
